import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { PendingStateUpdate } from './pending-state-update';
export { PendingStateUpdate };
import { pendingStateUpdateSchema } from '@schemas/business-objects/pending-state-update';
import { ProcessInstanceFormGroup } from './process-instance-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class PendingStateUpdateFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    triggerId: SchemaFormControl;
    timestamp: SchemaFormControl;
    processInstanceId: SchemaFormControl;
    processInstance: ProcessInstanceFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<PendingStateUpdate>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(pendingStateUpdateSchema, PendingStateUpdate, data, options);
  }

  get object(): PendingStateUpdate {
    return new PendingStateUpdate(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processInstance':
        return new ProcessInstanceFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<PendingStateUpdate[]> {
    return PendingStateUpdate.find(filter);
  }

  static async findOne(filter?: any): Promise<PendingStateUpdate | null> {
    return PendingStateUpdate.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<PendingStateUpdate> {
    return PendingStateUpdate.findById(id, filter);
  }

  static async create(
    data: Partial<PendingStateUpdate>,
  ): Promise<PendingStateUpdate> {
    return PendingStateUpdate.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<PendingStateUpdate>,
  ): Promise<PendingStateUpdate> {
    return PendingStateUpdate.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return PendingStateUpdate.deleteById(id);
  }
}

export class PendingStateUpdateFormArray extends PersistedFormArray {
  declare controls: PendingStateUpdateFormGroup[];

  readonly entityName = 'PendingStateUpdate' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(pendingStateUpdateSchema, PendingStateUpdate, options);
  }

  protected override createItemGroup() {
    return new PendingStateUpdateFormGroup();
  }

  get array(): PendingStateUpdate[] {
    return this.controls.map(
      (group: PendingStateUpdateFormGroup) => group.object,
    );
  }
}

export class PendingStateUpdatePersistedArray extends PersistedArray<PendingStateUpdate> {
  readonly entityName = 'PendingStateUpdate' as const;

  constructor(options?: PersistedArrayOptions) {
    super(PendingStateUpdate, options);
  }
}
